type Person = {
  name: string;
  patronymic: string;
  surname: string;
};

/** Возвращает полное имя из объекта */
export const getFullName = (person: Person) => {
  return `${person.surname} ${person.name} ${person.patronymic}`;
};
